import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {dismissNotification, removeNotification} from "../notifications-actions";
import BadgeNotification from './kinds/badge';

class Notifications extends React.Component {

    dismiss = (notification) => {
        this.props.dismissNotification(notification.id);
    };

    modalProps(notification) {
        return {
            key: notification.id,
            notification: notification,
            dismiss: this.dismiss
        }
    }

    render() {
        const {container = false, notifications, app} = this.props;

        let listClassName = `notifications__list`;
        if (container) listClassName += ' as-container';

        const filteredModals = notifications.modals.filter((notification) => notification.app === app);

        return (
            <div className='notifications'>
                <div className={listClassName}>
                    {
                        notifications
                            .list
                            .map((notification, index) => {
                                return (
                                    <div key={notification.id}
                                         className={'alert alert-dismissible alert-' + notification.type}>
                                        {notification.text}
                                        <button type="button" className="close" onClick={() => this.props.removeNotification(notification.id)}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                )
                            })
                    }
                </div>
                <div>
                    {
                        filteredModals
                            .slice(0, 1)
                            .map((notification) => {
                                switch (notification.type) {
                                    case "Notification::Badge": return (<BadgeNotification { ...this.modalProps(notification) }/>);
                                    default: return null;
                                }
                            })
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        notifications: state.notifications
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        removeNotification: removeNotification,
        dismissNotification: dismissNotification
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Notifications);
